import { gql, useQuery } from "@apollo/client";
import Button from "components/base/Button";
import Errors from "components/base/Errors";
import { Input } from "components/base/Form";
import InputSelect from "components/base/InputSelect";
import Spinner from "components/base/Spinner";
import { useEffect, useState } from "react";
import { BsTrash } from "react-icons/bs";

const FETCH_ALL_MATERIALS = gql`
  query FETCH_ALL_MATERIALS {
    allMaterials(withCostOnly: false) {
      id
      name
    }
  }
`;

const MaterialSelectInput = ({
  allMaterials,
  currentMaterial,
  currentMaterialIndex,
  setMaterials,
}) => {
  const [inputMaterial, setInputMaterial] = useState(currentMaterial.name);

  useEffect(() => {
    setInputMaterial(currentMaterial.name);
  }, [currentMaterial]);

  return (
    <InputSelect
      options={allMaterials.map((material) => ({
        name: material.name,
        material,
      }))}
      onSelect={(selectedOption) => {
        setInputMaterial(selectedOption.name);

        setMaterials((prev) =>
          prev.map((m, index) => {
            if (index === currentMaterialIndex) {
              return {
                ...m,
                name: selectedOption.name,
              };
            }
            return m;
          }),
        );
      }}
      onChange={setInputMaterial}
      value={inputMaterial}
      placeholder="Search a material"
      className="w-full"
    />
  );
};

const MaterialsInput = ({ className = "", materials, setMaterials }) => {
  // console.log("materials", materials);
  const { loading, error, data } = useQuery(FETCH_ALL_MATERIALS);

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  return (
    <div className={className}>
      {materials.map((m, index) => (
        <div key={index} className="flex mb-2 items-center">
          <MaterialSelectInput
            allMaterials={data.allMaterials}
            currentMaterial={m}
            currentMaterialIndex={index}
            setMaterials={setMaterials}
          />

          <div className="flex items-center space-x-2 ml-4">
            <span>&times; </span>
            <Input
              placeholder="Percentage"
              className="text-right w-20"
              value={m.percentage}
              onChange={(e) =>
                setMaterials((prev) =>
                  prev.map((j, jIndex) => {
                    if (index === jIndex)
                      return {
                        ...j,
                        percentage: e.target.value,
                      };
                    return j;
                  }),
                )
              }
            />
            <span>%</span>
          </div>

          <div className="w-full flex items-center space-x-2 mx-6">
            <label className="opacity-50">Remark:</label>
            <Input
              className="w-full"
              placeholder="Remark"
              value={m.remark}
              onChange={(e) =>
                setMaterials((prev) =>
                  prev.map((j, jIndex) => {
                    if (index === jIndex)
                      return {
                        ...j,
                        remark: e.target.value,
                      };
                    return j;
                  }),
                )
              }
            />
          </div>

          <div>
            <Button
              danger
              onClick={() =>
                setMaterials((prev) =>
                  prev.filter((_, prevIndex) => prevIndex !== index),
                )
              }
            >
              <BsTrash />
            </Button>
          </div>
        </div>
      ))}

      <Button
        onClick={() =>
          setMaterials((prev) => [
            ...prev,
            { name: "", percentage: 0, remark: "" },
          ])
        }
      >
        + Add Material
      </Button>
    </div>
  );
};

export default MaterialsInput;
